import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7e7f006c&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@/app/assets/styles/app.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3767387119/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e7f006c')) {
      api.createRecord('7e7f006c', component.options)
    } else {
      api.reload('7e7f006c', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=7e7f006c&", function () {
      api.rerender('7e7f006c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/App.vue"
export default component.exports